// extracted by mini-css-extract-plugin
module.exports = {"table-parent":"All_table-parent__1cZeo"};